import { Box, chakra } from '@stockx/ui';

export const Tile = chakra(Box, {
  baseStyle: {
    color: 'neutral.white',
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'flex-start',
    width: { base: '163px', md: 'initial' },
    _hover: {
      color: 'neutral.white',
    },
  },
  label: 'Tile',
});
